import React from 'react';
import { isOverseas } from '@moka-fe/ats.utils';
import { Modal } from 'sugar-design';

import { LOCALES, getI18n } from '@/utils/i18n';

import styles from './index.cm.styl';

const isDingtalk = window._MOKA_ENV_?.IS_DINGTALK;

const getLocalePrivacyPolicy = () => {
  if (isOverseas) {
    return {
      [LOCALES.ZH_CN]: 'https://hire-r1-public.mokahr.com/privacyPolicyToB.html',
      [LOCALES.EN_US]: 'https://hire-r1-public.mokahr.com/privacyPolicyToB-en.html',
    };
  }
  if (isDingtalk) {
    return {
      [LOCALES.ZH_CN]:
        'https://terms.alicdn.com/legal-agreement/terms/b_end_product_protocol/20231221142721132/20231221142721132.html',
      [LOCALES.EN_US]:
        'https://terms.alicdn.com/legal-agreement/terms/b_end_product_protocol/20231221142721132/20231221142721132.html',
    };
  }
  return {
    [LOCALES.ZH_CN]: 'https://public-cdn.mokahr.com/privacyPolicyToB.html',
    [LOCALES.EN_US]: 'https://public-cdn.mokahr.com/privacyPolicyToB-en.html',
  };
};

const LOCALE_SECRET_MAP = getLocalePrivacyPolicy();

export default class SecretModal extends React.Component {
  render() {
    const { className, canClose, onClose, onConfirm, previewMode, locale } = this.props;
    const i18n = getI18n(locale);

    let props = {};
    if (onClose) {
      props.onClose = onClose;
    }
    if (onConfirm) {
      props.onConfirm = onConfirm;
    }
    return (
      <Modal
        className={className}
        contentClassName={styles.modalContent}
        isOpen
        title={i18n.t`Moka隐私政策`}
        canCancel={false}
        confirmText={previewMode ? i18n.t`确定` : i18n.t`我已阅读并同意`}
        canClose={canClose}
        closeOnConfirm={!onConfirm}
        {...props}
      >
        <iframe src={LOCALE_SECRET_MAP[i18n.language]} className={styles.secret} />
      </Modal>
    );
  }
}
